import $ from 'jquery';
export var GaEventTrackType;
(function (GaEventTrackType) {
    GaEventTrackType["View"] = "view";
    GaEventTrackType["Click"] = "click";
})(GaEventTrackType || (GaEventTrackType = {}));
const ELEMENT_SELECTOR = '.js__ga-track';
export default class GaTracking {
    static $elements = $(ELEMENT_SELECTOR);
    static init($root = $('body')) {
        if ($root.length) {
            this.$elements = $root.find(ELEMENT_SELECTOR).addBack(ELEMENT_SELECTOR);
        }
        this.$elements.each((index, element) => {
            const $element = $(element);
            const { trackType, dataLayer } = $element.data();
            if (trackType === GaEventTrackType.View) {
                this.pushDataLayer(dataLayer);
            }
        });
        $root.off('click.gaTracking', ELEMENT_SELECTOR).on('click.gaTracking', ELEMENT_SELECTOR, e => {
            const $element = $(e.currentTarget);
            const { trackType, dataLayer, isMultipleEvents, preserveDefaultNavigation } = $element.data();
            const href = $element.attr('href');
            const descendantSelector = $element.attr('data-track-descendant');
            if (descendantSelector && !$(e.target).closest(descendantSelector).length) {
                return;
            }
            if (href && !preserveDefaultNavigation) {
                e.preventDefault();
                if ($element.attr('target') === '_blank') {
                    window.open(href, '_blank');
                }
                else {
                    window.location.href = href;
                }
            }
            if (trackType === GaEventTrackType.Click) {
                if (isMultipleEvents) {
                    dataLayer.forEach((datalayer) => {
                        this.pushDataLayer(datalayer);
                    });
                }
                else {
                    this.pushDataLayer(dataLayer);
                }
            }
        });
    }
    static pushDataLayer(dataLayer, isMultipleEvents) {
        if (dataLayer) {
            if (isMultipleEvents) {
                dataLayer.forEach((dataLayer) => {
                    window.dataLayer.push(dataLayer);
                });
            }
            else {
                window.dataLayer.push(dataLayer);
            }
        }
    }
}
